import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

export const ActionButton = styled(LoadingButton)({
	fontSize: '16px',
});
